import { useEffect, useState } from "react";
import { getBotStates } from "../../../services/auth";
import { showInfoToast } from "../../../utils/toast";
import { getBotsTemplates, uploadTemplateFile } from "../../../services/whatsapp_templates_admin";

const MAX_TEMPLATE_FILES_ALLOWED = 1

export default function useWhatsappTemplatesAdmin() {
    const [isLoading, setIsLoading] = useState(true);
    const [selectedTemplateFiles, setSelectedTemplateFiles] = useState([]);
    const [templatesData, setTemplatesData] = useState([]);
    const [trackerData, setTrackerData] = useState([]);

    const flattenTemplates = (data) => {
        return data.flatMap((bot) =>
            bot.templates.map((template) => ({
                ...template,
                bot_id: bot.bot_id,
                bot_name: bot.bot_name,
            }))
        );
    };

    const createTemplate = async () => {
        if (!selectedTemplateFiles.length) {
            showInfoToast("Debe seleccionarse un archivo.");
            return false;
        }

        if (selectedTemplateFiles.length > MAX_TEMPLATE_FILES_ALLOWED) {
            showInfoToast("Solo se admite un único archivo.");
            return false;
        }

        try {
            const data = await uploadTemplateFile(selectedTemplateFiles);

            if (!data) {
                showInfoToast("No se obtuvo respuesta del servidor.");
                return false;
            }

            setTrackerData(data);

            return true;
        } catch (error) {
            console.error("Error al crear plantilla:", error);
            showInfoToast("Ocurrió un error al procesar el archivo.");
            return false;
        }
    };

    const fetchData = async () => {
        const templates = await getBotsTemplates();
        if (templates) {
            setTemplatesData(templates);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return {
        isLoading,
        templatesData,
        flattenTemplates,
        createTemplate,
        selectedTemplateFiles,
        setSelectedTemplateFiles,
        trackerData
    };
}
